export const YANDEX_OAUTH_CALLBACK_PATH = '/callback_auth/yandex';
export const YANDEX_OAUTH_STATE_KEY = 'yandex_oauth_state';
